import {
    FETCH_ALL_ROOMS_BEGIN,
    FETCH_ALL_ROOMS_SUCCESS,
    FETCH_ALL_ROOMS_ERROR
  } from '../actions/getRooms';

import {
    ADD_ROOM_BEGIN,
    ADD_ROOM_SUCCESS,
    ADD_ROOM_ERROR
} from '../actions/addRoom'

import {
    DELETE_ROOM_BEGIN,
    DELETE_ROOM_SUCCESS,
    DELETE_ROOM_ERROR
} from '../actions/deleteRoom'

  const initialState = {
    data: [],
    isLoading: false,
    error: null
  };

  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ALL_ROOMS_BEGIN:
      case ADD_ROOM_BEGIN:
      case DELETE_ROOM_BEGIN:
        return {
          ...state,
          isLoading: true,
          error: null
        };

      case FETCH_ALL_ROOMS_SUCCESS:
        return {
          ...state,
          isLoading: false,
          data: action.payload.data
        };

      case DELETE_ROOM_SUCCESS:
      case ADD_ROOM_SUCCESS:
        return {
          ...state,
          isLoading: false,
          error: null
        };


      case FETCH_ALL_ROOMS_ERROR:
      case DELETE_ROOM_ERROR:
        return {
          ...state,
          isLoading: false,
          error: action.payload.error,
          data: []
        };

      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/reducers/roomsReducer.js